<template>
  <div class="container">
    <div class="header">
      <p style="color:#526069;font-size: 18px">企业交易数据</p>
      <el-button type="primary" style="height: 35px;width: 126px;line-height: 10px;color: #fff;" @click="exportExcel" :disabled="excelBtn">导出报表</el-button>
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">
      <el-form-item label="订单编号:">
        <el-input class="ein"  v-model="formInline.orderId" placeholder="请输入订单编号"></el-input>
      </el-form-item>

      <el-form-item class="efi" label="企业名称:">
        <el-input class="ein"  v-model="formInline.user" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item class="efi" label="类型:">
        <el-select class="ein"  v-model="formInline.type" placeholder="请选账单类型">
          <el-option label="福利发放" value="1"></el-option>
          <el-option label="充值" value="2"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="header">
      <el-form :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">
        <el-form-item label="时间范围:">
          <el-col :span="11">
            <el-date-picker :clearable="false"  type="date" placeholder="选择查询起始时间" v-model="formInline.date1" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align: center;">  -</el-col>
          <el-col :span="11">
            <el-date-picker :clearable="false"  type="date" placeholder="选择查询结束时间" v-model="formInline.date2" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <div style="margin-right: 20px;">
        <el-button type="primary" style="height: 35px;line-height: 10px;" @click="getCompanyDealData(1)">查询</el-button>
        <el-button type="info" style="height: 35px;line-height: 10px;" @click="resetForm">重置</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      stripe
      :header-cell-style="cell"
      :row-style="row"
      style="width: 100%;">
      <el-table-column
        align="center"
        prop="ref_order_id"
        width="180"
        label="订单编号">
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="企业名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fundDirection"
        :formatter="typeFormat"
        label="类型"
        >
      </el-table-column>
      <el-table-column
        align="center"
        prop="amount"
        :formatter="tofixed"
        label="金额(元)">
      </el-table-column>
      <el-table-column
        align="center"
        prop="tradeName"
        label="交易方">
      </el-table-column>

      <el-table-column
        align="center"
        prop="create_time"
        :formatter="dateFormat"
        label="时间">
      </el-table-column>

    </el-table>
    <el-pagination
      class="pagi"
      background
      layout="prev, pager, next,jumper"
      :total="total"
      @current-change='getCompanyDealData'
      >
    </el-pagination>
  </div>

</template>

<script>
import { toFixed,compareTime } from "@/utils";
import {downloadExcel} from '@/utils/downloadFetch'
import { getCompanyDeal } from "@/api/finance";
import {shop_url} from '@/global';
export default {
  name: "",
  props: [""],
  data() {
    return {
      formInline: {
        orderId: "",
        user: "",
        type: "",
        date1: "",
        date2: ""
      },
      tableData: [],
      page: 1,
      total: 0,
      pageSize: 10,
      excelBtn:false
    };
  },
  mounted() {
    this.getCompanyDealData(1);
  },

  methods: {
    tofixed(row, column, cellValue) {
      return toFixed(cellValue);
    },
    cell() {
      return {
        textAlign: "center",
        color: "#526069",
        fontSize: "14px"
      };
    },
    row() {
      return {
        height: "36px",
        textAlign: "center",
        color: "#7d8893",
        fontSize: "14px"
      };
    },
    getCompanyDealData(page) {
      this.page = page;
      let {date1,date2} = this.formInline;
      let flag = compareTime(date1,date2)
      if(flag){
        getCompanyDeal(this.formInline, page, this.pageSize)
          .then(res => {
            this.tableData = res.data.list;
            this.total = res.data.count;
          })
          .catch(error => {});
      }else{
        this.$notify({
            title: "提示",
            message:'请正确选择时间',
            type:'warning',
            duration: 800
          });
      }
    },
    exportExcel(){
      this.excelBtn = true;
      this.formInline.start = this.formInline.date1;
      this.formInline.end = this.formInline.date2;
      downloadExcel({method:'post',fileName:'企业交易数据报表.xls',url:`${shop_url}/shop/cms/print/company`,data:this.formInline}).then(res=>{
        console.log(res)
      }).then(res => {
        this.excelBtn = false;
        console.log(res);
      }).catch(err => {
        this.excelBtn = false;
      });
    },
    resetForm() {
      this.formInline.user = "";
      this.formInline.orderId = "";
      this.formInline.type = "";
      this.formInline.date1 = "";
      this.formInline.date2 = "";
      this.getCompanyDealData(1);
    },
    dateFormat(row, column) {
      return this.uwsToDate(row[column.property]);
    },
    typeFormat(row, column) {
      let str = "";
      switch (row[column.property]) {
        case 1:
          str = "福利发放";
          break;
        case 2:
          str = "充值";
          break;
      }
      return str;
    }
  }
};
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 30px;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
}
.el-input {
  border-bottom: 240px #d1dee1;
}
.ein {
  width: 240px;
}
.efi {
  margin-left: 50px;
}
.pagi {
  align-self: center;
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/CompanyDealData.vue